import { useEffect } from "react";

export const useHotjarIdentify = ({
  userId,
  email,
  role,
}: {
  userId: string | null | undefined;
  email: string | null | undefined;
  role: "PROVIDER" | "CLIENT";
}) => {
  useEffect(() => {
    if (window.hj && typeof window.hj === "function" && userId && email) {
      window.hj("identify", userId, {
        email,
        role,
      });
    }
  }, [window.hj, userId, email, role]); // eslint-disable-line react-hooks/exhaustive-deps
};
